import React, { useState, useEffect, useContext, useMemo } from "react";
import { Field, Formik } from "formik";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import Layout from "components/Layout";
import SubTitle from "components/SubTitle";
import BrokingSummary from "components/BrokingSummary";
import ContentCard from "components/ContentCard";
import { Row, Col } from "components/Grid";
import FormContainer from "components/FormContainer";
import Icon from "components/Icon";
import ComboBox from "components/Form/ComboBox3";

import { FitinsurAPI, MessageCenter } from "utils";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import Colors from "constants/Colors";
import ListDetail from "./listDetail";
import {
  Text,
  TagInput,
  PlaceHolder,
  BackToList,
  Heading,
  ButtonContainer,
} from "./styles";

export default function DocumentManagement(props) {
  const coluns = [
    {
      title: "Document Name",
      value: "nmParty",
    },
    {
      title: "Version",
      value: "nmInterest",
    },
    {
      title: "Document Type",
      value: "documentType",
    },
    {
      title: "Uploaded By",
      value: "uploadBy",
    },
    {
      title: "Date",
      value: "date",
    },

    {
      title: "Action",
      value: "action",
    },
  ];

  const authContext = useContext(GlobalAuthContext);
  const [sortList, setSortList] = useState([]);
  const [filter, setFilter] = useState({
    key: null,
    direction: null,
  });
  const [data, setData] = useState([
    /* { nmParty: '', nmInterest: '', documentType: '', uploadBy: '', date: '', action: '' } */
  ]);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const [searchList, setSearchList] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [sumaryData, setSumaryData] = useState({});
  const [insurer, setInsurer] = useState("");
  const [quote, setQuote] = useState({
    idOperation: "",
    proponent: "",
    email: "",
    cpfOrCnpj: "",
    previousInsurer: "",
    susep: "",
    marketingBranches: [],
    sufferedComplaintsFiveYears: "",
    possibleComplaints: "",
    effectiveDate: "",
    retroactivity: "",
    annualBilling: "",
    transportBilling: "",
    product_plans: [],
    coverages: [],
    limits: [],
    documents: [],
  });
  const [plan, setPlan] = useState(null);

  useMemo(() => {
    setSortList(data);
    if (sortList) {
      sortList.sort((a, b) => {
        if (a[filter.key] < b[filter.key])
          return filter.direction === "asc" ? -1 : 1;
        if (a[filter.key] > b[filter.key])
          return filter.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
  }, [filter, data]);

  //---------------------------
  //-- data of header
  //---------------------------
  useEffect(() => {
    async function requestGetQuoteFormatted() {
      if (authContext.status !== true) {
        mc.error("Usuário não autenticado");
        history.push("/login");
        return;
      }

      console.log("planplanplanplan", plan);

      setInsurer(
        plan &&
          plan.product_plan_name &&
          plan.product_plan_name.indexOf("Argo") >= 0
          ? "argo"
          : "fator"
      );

      loading.start();
      fitinsur.setAuthToken(authContext.token);
      fitinsur
        .requestGetQuote(
          props.match.params.idProduct,
          props?.match?.params?.idOperation
        )
        // .requestGetQuote(15, 220791)
        .then((x) => x.json())
        .then((response) => {
          if (response.ret_code != 200) {
            mc.error(response.ret_msg_details);
            return loading.stop();
          }
          const { ret_value } = response;
          const getUniqObjBeetweenSames = (array) =>
            array
              .map((item) => ({
                answer: item.answer,
                idQuestion: item.idQuestion,
                dsQuestion: item.dsQuestion,
              }))
              .filter(
                (item, pos, self) =>
                  self.findIndex(
                    (v) =>
                      v.answer === item.answer &&
                      item.idQuestion == v.idQuestion
                  ) === pos
              );
          const risks = getUniqObjBeetweenSames(ret_value.risks);
          const operations = getUniqObjBeetweenSames(ret_value.operations);
          const mapCoverages = ret_value.resultProductPlans.coverageCalc
            .map((item) => [
              ...item.coverageCalc.map((coverage) => ({
                ...coverage,
                idProductPlan: item.id_product_plan,
              })),
            ])
            .flat();
          const flatCoverages = mapCoverages.map((item) => item.coverageLimit);
          const limits = flatCoverages.filter(
            (item, index, self) => self.indexOf(item) == index
          );
          const coverages = limits.map((limit) => {
            const plans = mapCoverages
              .map((item) => (item.coverageLimit == limit ? item : false))
              .filter(Boolean);
            return { limit, plans };
          });
          const { idOperation } = ret_value;
          const proponent = ret_value.persons.find(
            (item) => item.idQuestion == 145
          ).answer;
          const email = ret_value.persons.find((item) => item.idQuestion == 144)
            .answer;
          const cpfOrCnpj = ret_value.persons.find(
            (item) => item.idQuestion == 143
          ).answer;
          const susep = ret_value.persons.find((item) => item.idQuestion == 146)
            .answer;
          const marketingBranches = risks
            .map(({ idQuestion, answer }) =>
              idQuestion == 150 ? answer : false
            )
            .filter(Boolean);
          const sufferedComplaintsFiveYears = risks.find(
            ({ idQuestion }) => idQuestion == 152
          ).answer;
          const possibleComplaints = risks.find(
            ({ idQuestion }) => idQuestion == 153
          ).answer;
          const effectiveDate = risks.find(
            ({ idQuestion }) => idQuestion == 154
          ).answer;
          const retroactivity = risks.find(
            ({ idQuestion }) => idQuestion == 163
          ).answer;
          const annualBilling = risks.find(
            ({ idQuestion }) => idQuestion == 149
          ).answer;
          const transportBilling = risks.find(
            ({ idQuestion }) => idQuestion == 151
          ).answer;

          const objQuote = {
            idOperation,
            proponent,
            email,
            cpfOrCnpj,
            susep,
            marketingBranches,
            sufferedComplaintsFiveYears,
            possibleComplaints,
            effectiveDate,
            retroactivity,
            annualBilling,
            transportBilling,
          };

          setQuote({
            ...objQuote,
            previousInsurer: operations.find(
              ({ idQuestion }) => idQuestion == 148
            ).answer,
            product_plans: ret_value.resultProductPlans.product_plan,
            coverages,
            limits,
            documents: ret_value.resultProductPlans.document,
          });
          setPlan(ret_value.operation.metadata.currentPlan);
          setSumaryData(objQuote);
          loading.stop();

          getFiles();

        })
        .catch((e) => {
          loading.stop();
          console.log(e);
        });
    }
    requestGetQuoteFormatted();
  }, []);

  const getFiles = () => {
    console.log("getFiles - START");
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetDealDocuments(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          loading.stop();
          return;
        }
        loading.stop();
        //console.log("getFiles - setDocuments: ",data.ret_value)
        setDocuments(data.ret_value);
    })
  }  

  const handleUpload = (file) => {
    const bodyAttach = {
      create: true,
      operationsQuestionnaire: [
        {
          isFile: true,
          file: {
            fileName: file.fileName,
            size: file.size,
            fileBase64: file.fileBase64,
            documentType: {
              idAnswerOption: file.documentType
                ? file.documentType.idAnswerOption
                : undefined,
              dsAnswerOption: file.documentType
                ? file.documentType.dsAnswerOption
                : undefined,
            },
          },
        },
      ],
    };

    console.log("bodyAttach", bodyAttach);

    loading.start();
    fitinsur.setAuthToken(authContext.token);

    bodyAttach.idOperation = props.match.params.idOperation;
    fitinsur
      .uploadInternalAttachment(bodyAttach)
      .then((res) => res.json())
      .then((res) => {
        console.log("resresresresres", res);
        if (res.ret_code === 200) {
          loading.stop();
        } else {
          mc.error(res.ret_msg_details);
          loading.stop();
        }
      });
  };

  function handleSortList(key) {
    let direction = "asc";
    if (filter.key === key && filter.direction === "asc") direction = "desc";
    setFilter({ key: key, direction: direction });

    console.log("Lista Ordenada-> ", sortList);
    console.log("Ordem key-> ", filter.direction);
  }

  const fieldRenderOptions = (options = []) => {
    let result = [];
    options.forEach((option) => {
      result.push({
        label: option.ANSWER_OPTION_DESCRIPTION,
        value: {
          idAnswerOption: option.ID_ANSWER_OPTION,
          dsAnswerOption: option.ANSWER_OPTION_DESCRIPTION,
        },
      });
    });
    console.log("result", result);
    return result;
  };

  function renderDocuments(title, nameArray, hasUpload, hasDelete) {
    return (
      <>
        <FormContainer title={title}>
          <Row
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {coluns
              ? coluns.map((colun, index) => (
                  <Col
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      onClick={() => handleSortList(colun.value)}
                      style={{ margin: "0 auto", textTransform: "uppercase" }}
                    >
                      {colun.title}
                    </Text>
                    {colun.title == "Action" ? null : filter.key ===
                        colun.value && filter.direction === "asc" ? (
                      <FontAwesomeIcon
                        icon={faChevronUp}
                        color={Colors.GRAY[6]}
                        size="1x"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        color={Colors.GRAY[6]}
                        size="1x"
                      />
                    )}
                  </Col>
                ))
              : ""}
          </Row>
          {documents[nameArray] &&
            documents[nameArray].map((document, index) => {
              return (
                <React.Fragment key={index}>
                  <ListDetail
                    document={document}
                    idOperation={props.match.params.idOperation}
                    listDocuments={documents}
                    hasDelete={hasDelete}
                  />
                  <hr />
                </React.Fragment>
              );
            })}
        </FormContainer>
      </>
    );
  }

  return (
    <Layout
      title="Inovação Corretora"
      subtitle="Responsabilidade Civil Profissional Corretor de Seguros"
    >
      <SubTitle
        stage={3}
        idProduct={props.match.params?.idProduct}
        idOperation={props.match.params?.idOperation}
      />
      <BrokingSummary data={sumaryData} />
      <ContentCard title="Documentos">
        {renderDocuments(
          "DOCUMENTOS SEGURADORA",
          "insurerDocuments",
          false,
          false
        )}
        {renderDocuments("DOCUMENTOS GERADOS", "dealDocuments", false, false)}
        {renderDocuments(
          "DOCUMENTOS DE SUPORTE",
          "supportDocuments",
          false,
          true
        )}
        {renderDocuments(
          "DOCUMENTOS INTERNOS",
          "internalDocuments",
          true,
          true
        )}
        <Formik
          enableReinitialize={true}
          initialValues={{}}
          render={({ values, setFieldValue }) => (
            <Row style={{ marginTop: 30 }}>
              <Col md={5} sm={6} xs={5}>
                <Field
                  name="documentType"
                  label="Tipo de Documento"
                  type="text"
                  isRequired={false}
                  component={ComboBox}
                  options={fieldRenderOptions(documents["documentTypes"])}
                  value={values.documentType}
                  searchList={searchList}
                  onChange={(value) => {
                    setFieldValue("documentType", value);
                  }}
                  onFocus={(e) => {
                    setSearchList([]);
                  }}
                  onSearchSelect={(e) => {
                    console.log("onSearchSelect", e);
                  }}
                />
              </Col>
              <Col md={4} sm={6} xs={6}>
                <ButtonContainer>
                  <PlaceHolder htmlFor="fileInput">CONFIRMAR</PlaceHolder>
                  <TagInput
                    id="fileInput"
                    name="fileInput"
                    type="file"
                    multiple={false}
                    onChange={(event) => {
                      if (!values.documentType) return mc.error("Please, specify the document type.");

                      if (!event.target.files[0]) return mc.error("Invalid file, please select a valid one.");

                      loading.start();

                      let reader = new FileReader();
                      let fileR = event.target.files[0];
                      reader.onloadend = () => {
                        let result = Buffer.from(reader.result).toString(
                          "base64"
                        );
                        handleUpload({
                          documentType: values.documentType,
                          fileName: fileR.name,
                          fileBase64: result,
                          size: fileR.size,
                          type: fileR.type,
                        });
                        setFieldValue("documentType", null);
                      };

                      reader.onerror = () => loading.stop();
                      reader.readAsArrayBuffer(fileR);
                    }}
                  />
                </ButtonContainer>
              </Col>
              <Col md={3} sm={0} xs={0}></Col>
            </Row>
          )}
        />
      </ContentCard>
      <ButtonContainer>
        <BackToList onClick={() => history.push("/quotes")}>
          <Icon name="vector" />
          <Heading style={{ fontSize: 16 }}>VOLTAR PARA LISTA</Heading>
        </BackToList>
      </ButtonContainer>
    </Layout>
  );
}
